import { render, staticRenderFns } from "./FormProducto.vue?vue&type=template&id=a9205b08&scoped=true"
import script from "./FormProducto.vue?vue&type=script&lang=js"
export * from "./FormProducto.vue?vue&type=script&lang=js"
import style0 from "./FormProducto.vue?vue&type=style&index=0&id=a9205b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9205b08",
  null
  
)

export default component.exports